<div class="form-field-wrapper">
  @if(!viewMode) {
    <div class="form-check">
      <input class="form-check-input" [formControl]="formControl" (change)="onChangeCheckbox($event)" type="checkbox" id="checkbox{{label}}">
      <label class="form-field-label form-field-label__checkbox {{customClass}}">
        <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
        {{ label }}
      </label>
    </div>
  } @else {
    <div class="d-flex form-check-overview">
      <label
        class="form-field-label form-field-label__overview form-field-label__overview__checkbox {{customClass}}"
        [ngClass]="{'text-secondary' : formControl.status === 'DISABLED' }"
      >
        <app-input-helper-text [helpText]="helpText"></app-input-helper-text>
        {{ label }}
      </label>
      <input class="form-check-input" [formControl]="formControl" (change)="onChangeCheckbox($event)" type="checkbox" id="checkbox{{label}}" >
    </div>
  }
</div>
